import React, { useCallback, useEffect, useRef, useState } from "react";
import Header from "./Header";
import "./GallaryCard.scss";
import {
  getTextWithWrapHtml,
  sentimentColor,
} from "../../../../../redux/constants";
import GallaryAttachments from "./GallaryAttachments";
import CardStats from "./CardStats";
import PostCardDetails from "../../../../WidgetMaker/PostCardDetails";
import { setPauseAnimationWhenPopupOpen } from "../../../../../redux/actions/commandCenter/screens/screen";
import { useDispatch, useSelector } from "react-redux";
import isEqual from "react-fast-compare";
import { Tooltip } from "antd";
import { MentionIdComponent } from "../../../../WidgetMaker/MentionIdComponent";
import { sentimentClass } from "../../../../../redux/constants/enums";
const GallaryCard = ({
  cardData,
  animatedClass,
  activeClass,
  cardSlideClass,
  cardScaleDown,
  center,
  isCurrentSlide,
  index,
  isLeaderBoard,
  metadata,
  isCommandCenterScreen,
  isDetailView = false,
  onClickHandleTrends,
  setShowState,
}) => {
  const dispatch = useDispatch();
  const personalizationSettingsObj = useSelector(
    (state) => state?.PersonalizationSetting
  );
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isModalLoader, setIsModalLoader] = useState(false);
  const [modalData, setIsModalData] = useState(null);
  const refOfCardHeader = useRef(null);
  const [refIndicatorOfCardHeader, setRefIndicatorOfCardHeader] =
    useState(false);
  // callback function got called when reference of header is updated
  const measuredRefOfCardHeader = useCallback((node) => {
    if (node !== null) {
      refOfCardHeader.current = node;
      setRefIndicatorOfCardHeader(!refIndicatorOfCardHeader);
    }
  }, []);
  const refOfCardDescContent = useRef(null);
  const [refIndicatorOfCardDescContent, setRefIndicatorOfCardDescContent] =
    useState(false);
  const authParams = useSelector((state) => state.Authentication.authParams);
  // callback function got called when reference of card content is updated
  const measuredRefOfCardDescContent = useCallback((node) => {
    if (node !== null) {
      refOfCardDescContent.current = node;
      setRefIndicatorOfCardDescContent(!refIndicatorOfCardDescContent);
    }
  }, []);
  // this useEffect is indicate the rerendering in case of header and card content size is updated
  useEffect(() => {
    setRefIndicatorOfCardHeader(!refIndicatorOfCardHeader);
    setRefIndicatorOfCardDescContent(!refIndicatorOfCardDescContent);
  }, [
    refOfCardDescContent?.current?.clientHeight,
    refOfCardHeader?.current?.clientHeight,
  ]);
  const showModal = (data) => {
    if (personalizationSettingsObj?.isPersonalizationPreviewOpen) {
      return;
    }
    dispatch(setPauseAnimationWhenPopupOpen(true));
    setIsModalLoader(true);
    setIsModalOpen(true);
    setIsModalData(data);
  };
  return (
    <>
      <div
        alignment="center"
        className={`gallary_card text-center bg__color--primary-dark card__border ${
          animatedClass ? animatedClass : ""
        } ${activeClass ? activeClass : ""} ${
          cardSlideClass ? cardSlideClass : ""
        } ${cardScaleDown ? cardScaleDown : ""}`} // ${active ? "active-in" : "active-out"}
      >
        <div
          // style={{
          //   "--border-color-mention":
          //     sentimentColor[cardData.SentimentType] || "none",
          // }}
          className={`gallarycard__body gallery-card-mention-sentiment ${
            sentimentClass[cardData?.SentimentType] || "default-text-color"
          }`}
        >
          {center || isCurrentSlide ? (
            <>
              {/* <MentionIdComponent
                color={
                  sentimentColor[cardData?.SentimentType] ||
                  (authParams?.screen_id ? "#7493FF" : "none")
                }
                backgroudColor={authParams?.screen_id ? "#F4EBFD" : "#FFFEF9"}
                id={cardData?.mention_id}
                right={
                  authParams?.screen_id === "000-000-551"
                    ? // authParams?.screen_id === "000-000-561"
                      "44px"
                    : "0"
                }
                top={
                  authParams?.screen_id === "000-000-561" ? "-10px" : "-24px"
                }
              /> */}
              <div
                className="gallarycard__header--wrapper"
                ref={measuredRefOfCardHeader}
              >
                <Header
                  cardData={cardData}
                  animatedClass={animatedClass}
                  activeClass={activeClass}
                  cardSlideClass={cardSlideClass}
                  cardScaleDown={cardScaleDown}
                  center={center}
                  isCurrentSlide={isCurrentSlide}
                  index={index}
                  isLeaderBoard={isLeaderBoard}
                  custom_card_settings={
                    metadata?.chart?.chart_settings?.custom_card_settings
                  }
                  metadata={metadata}
                  isDetailView={isDetailView}
                  onClickHandleTrends={onClickHandleTrends}
                />
              </div>
            </>
          ) : (
            ""
          )}

          <div
            className="gallarycard__content"
            style={{
              height:
                "calc(100% - " +
                (refOfCardHeader?.current?.clientHeight
                  ? refOfCardHeader?.current?.clientHeight
                  : 0) +
                "px)",
            }}
          >
            {cardData?.Attachment?.length > 0 ? (
              <div
                className="gallarycard__attachments"
                style={{
                  height:
                    "calc(" +
                    (isDetailView ? "55rem" : "100%") +
                    " - " +
                    ((refOfCardDescContent?.current?.clientHeight &&
                    !isDetailView
                      ? refOfCardDescContent?.current?.clientHeight
                      : 0) +
                      (center || isCurrentSlide ? 10 : 0)) +
                    "px)",
                }}
              >
                <GallaryAttachments
                  cardData={cardData}
                  index={index}
                  isCommandCenterScreen={isCommandCenterScreen}
                  // isPreviewState={isPreviewState}
                  // postText={cardData?.mention_text}
                  custom_card_settings={
                    metadata?.chart?.chart_settings?.custom_card_settings
                  }
                  gallaryCardHeight={
                    "calc(100% - " +
                    ((refOfCardDescContent?.current?.clientHeight
                      ? refOfCardDescContent?.current?.clientHeight
                      : 0) +
                      (center || isCurrentSlide ? 10 : 0)) +
                    "px)"
                  }
                  center={center}
                  isCurrentSlide={isCurrentSlide}
                />
                {center || isCurrentSlide ? (
                  <div className="gallarycard__stats gallarycard__stats--absolute">
                    <CardStats
                      cardData={cardData}
                      index={index}
                      custom_card_settings={
                        metadata?.chart?.chart_settings?.custom_card_settings
                      }
                    />
                  </div>
                ) : (
                  ""
                )}
              </div>
            ) : (
              <>
                {center || isCurrentSlide ? (
                  <div className="gallarycard__stats gallarycard__stats--relative">
                    <CardStats
                      cardData={cardData}
                      index={index}
                      custom_card_settings={
                        metadata?.chart?.chart_settings?.custom_card_settings
                      }
                    />
                  </div>
                ) : (
                  ""
                )}
              </>
            )}
            {(center || isCurrentSlide) && cardData?.mention_text ? (
              <div
                className="gallarycard__description text-primary-font-size"
                ref={measuredRefOfCardDescContent}
              >
                {cardData?.mention_text ? (
                  <div
                    className={`${
                      cardData?.Attachment?.length === 0
                        ? "post-text__size"
                        : ""
                    } w-100`}
                  >
                    {getTextWithWrapHtml(
                      cardData?.mention_text?.length > 180 &&
                        cardData?.Attachment?.length > 0 &&
                        !isDetailView
                        ? cardData?.mention_text?.slice(0, 180)
                        : cardData?.mention_text,
                      "text-initial truncate-text break-word"
                    )}
                    {cardData?.mention_text?.length < 180 || isDetailView ? (
                      ""
                    ) : cardData?.mention_text?.length > 180 &&
                      cardData?.Attachment?.length > 0 ? (
                      <Tooltip
                        title={
                          personalizationSettingsObj?.isPersonalizationPreviewOpen
                            ? "Actions are not allowed while customizing"
                            : ""
                        }
                      >
                        <span
                          className={`blue-text ${
                            center &&
                            isCurrentSlide &&
                            !personalizationSettingsObj?.isPersonalizationPreviewOpen
                              ? "cursor-pointer"
                              : "disabled-cursor"
                          }`}
                          style={{
                            pointerEvents:
                              center && isCurrentSlide ? "all" : "none",
                          }}
                          onClick={() => showModal(cardData)}
                        >
                          ... Read More
                        </span>
                      </Tooltip>
                    ) : (
                      ""
                    )}
                  </div>
                ) : (
                  ""
                )}
              </div>
            ) : (
              ""
            )}
          </div>
        </div>
      </div>
      {/* Post Card and On Click Read more, Post Details Modal Component */}
      {center && isCurrentSlide ? (
        <PostCardDetails
          data={cardData}
          modalData={modalData}
          metadata={metadata}
          isPreviewState={false}
          PdfDownloadStatus={false}
          PptGeneratingStatus={false}
          setIsModalOpen={setIsModalOpen}
          isModalOpen={isModalOpen}
          setIsModalData={setIsModalData}
          isModalLoader={isModalLoader}
          setIsModalLoader={setIsModalLoader}
        />
      ) : (
        ""
      )}
    </>
  );
};
export default React.memo(GallaryCard, isEqual);
